import usePortfolio from "../../hooks/PortfolioProvider";
import { ForwardedRef, forwardRef } from "react";
import Dropdown, { IDropdown, TDropdownProps } from "../../gui/Dropdown/Dropdown";
import { TSelect } from "../../gui/Select/Select";
import { EAccountTypes } from "../../shared/IAccount";
import _ from "lodash";

export type TAccountSelectProps = Omit<TDropdownProps<number>, "options"|"anchorProps"|"float"> & {
    showAll?:boolean;
    placeholder?:string
}
type TAccountRow = TSelect<number> & { type:EAccountTypes }
export default forwardRef((props:TAccountSelectProps, ref?:ForwardedRef<IDropdown<number>>) => {
    const {showAll,...listProps} = props
    const {portfolio} = usePortfolio()

    const options : TAccountRow[] = portfolio.accounts.map(account => ({text:account.name,id:account.id,type:account.type}))
    options.sort((l,r) => l.type==r.type ? l.text.localeCompare(r.text) : l.type-r.type)
    if (props.showAll) options.unshift({id:-1,text:"All",type:0})

    return <Dropdown className="accounts" ref={ref} options={options} placeholder={props.placeholder || "Account"} float={true} anchorProps={{width:"match"}} {...listProps}/>
})